import { StyleSheet } from 'react-native';
export var getAcknowledgeWidgetStyles = props => {
  var borderPadding = props.borderPadding,
    borderBackgroundColor = props.borderBackgroundColor;
  return StyleSheet.create({
    container: {
      padding: borderPadding,
      backgroundColor: borderBackgroundColor
    }
  });
};